// @flow

import type { LngLatZ, LocationDescriptor } from "Shared/LocationDescriptor/LocationDescriptor";

// function getParamString (obj) {
//     var params = [];
//     for (var i in obj) {
//         params.push(i + '=' + encodeURIComponent(obj[i]));
//     }
//     return params.join('&');
// }

// function generateRouteUrl(start, dest){
//     // https://use.mazemap.com/?v=1&starttype=point&start=10.38792%2C63.42007%2C1&desttype=point&dest=10.38777%2C63.41972%2C1
//     var baseUrl = "https://use.mazemap.com/?v=1&";
//     var reqOpts = {
//         starttype: start.type,
//         start: encodeUrlCoordParam(start),
//         desttype: dest.type,
//         dest: encodeUrlCoordParam(dest)
//     }

//     var finalUrl = baseUrl + getParamString(reqOpts);
//     return finalUrl;

// }

function getURLParameter(sUrl: string, sParam: string){
    var sPageURL = sUrl;
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++){
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam){
            return decodeURIComponent(sParameterName[1]);
        }
    }
}

function decodeUrlCoordParam(type, data){
    var split = data.split(',');
    var result: LocationDescriptor = {type: type};

    if(type === 'point'){
        result.lngLat = { lng: Number(split[0]), lat: Number(split[1]) };
        var zLevel = Number(split[2]);
        if(zLevel){
            result.zLevel = zLevel;
        }
    }else if( type === 'poi'){
        result.poiId = Number(split[0]);
    }else if( type === 'identifier'){
        result.identifier = String(split[0]);
    }else if(!type || !data){
        throw new Error("Bad type or data given to decode");
    }

    return result;
}

function encodeLngLatZCoordParam(lngLatZ: LngLatZ){
    if( lngLatZ.zLevel ){
        return [lngLatZ.lngLat.lng, lngLatZ.lngLat.lat, lngLatZ.zLevel].join(',');
    }else{
        return [lngLatZ.lngLat.lng, lngLatZ.lngLat.lat].join(',');
    }
}

type RoutePointTypeString = 'start' | 'dest';

function getRoutePointUrlParams(type:RoutePointTypeString, point:LocationDescriptor){
    // TODO: Make LocationDescriptor a class with method #toURLComponent() or similar

    let point_type;
    let point_encoded;

    if( point.hasOwnProperty('poiId') ){
        point_type = 'poi';
        point_encoded = point.poiId.toString();
    }else if( point.hasOwnProperty('lngLat') ){
        point_type = 'point';
        point_encoded = encodeLngLatZCoordParam(point);
    }else if( point.hasOwnProperty('identifier') ){
        point_type = 'identifier';
        point_encoded = point.identifier.toString();
    }

    if( type === 'start'){
        return {
            starttype: point_type,
            start: point_encoded
        };
    }else if( type === 'dest' ){
        return {
            desttype: point_type,
            dest: point_encoded
        };
    }else{
        throw new Error("Wrong input type given: " + type);
    }
}

function parseRouteUrl(url: string){
    var startType = getURLParameter(url, 'starttype');
    var startData = getURLParameter(url, 'start');
    var destType = getURLParameter(url, 'desttype');
    var destData = getURLParameter(url, 'dest');

    var start:LocationDescriptor = startData ? decodeUrlCoordParam(startType, startData) : null;
    var dest:LocationDescriptor = destData ? decodeUrlCoordParam(destType, destData) : null;

    return {
        start: start,
        dest: dest
    }
}

module.exports = {
    getURLParameter: getURLParameter,
    parseRouteUrl: parseRouteUrl,
    getRoutePointUrlParams: getRoutePointUrlParams,
    encodeLngLatZCoordParam: encodeLngLatZCoordParam,
}


// WEBPACK FOOTER //
// src/Shared/UrlParser/RouteParser.js